import { Box, Button, Modal, Text, useMantineTheme } from "@mantine/core";
import { AlertCircle, CircleCheck, CircleX } from "tabler-icons-react";

import React from "react";

import { GenericPopUpProps } from "../../types/types";

import { themeProvider } from "../style/utils";

import "./genericPopUp.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

export function GenericPopUp(props: GenericPopUpProps) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const theme = useMantineTheme();
  const closeModal = () => {
    props.setOpenGenericModal(false);
    if(  props.onCloseCallback)
      props.onCloseCallback()
    };

  return (
    <div>
      <Modal
        withCloseButton={false}
        zIndex={100000}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        style={{ marginTop: "14rem" }}
        opened={props.openGenericModal}
        onClose={closeModal}
        radius="md"
        size="500px"
        className="genericPopUp-modalContainer"
      >
        <div className="genericPopUp-container">
          <Box>
            <Box
              sx={() => ({
                display: "flex",
                justifyContent: "center",
              })}
            >
              {props.type === "Success" && (
                <CircleCheck size={56} strokeWidth={2} color="#1c7ea0" />
              )}
              {props.type === "Alert" && (
                <AlertCircle size={56} strokeWidth={2} color="#1c7ea0" />
              )}
              {props.type === "Error" && (
                <CircleX size={56} strokeWidth={2} color="#1c7ea0" />
              )}
            </Box>

            <Text
              size="xl"
              align="center"
              sx={() => ({
                width: "100%",
                justifyContent: "center",
                marginBottom: "6%",
                marginTop: "6%",
                fontSize: "16px",
                paddingLeft: "3rem",
                paddingRight: "3rem",
              })}
            >
               {translate(TranslationEnum.common_portal,props.message)}
            </Text>
            <Box>
              <Box className="genericPopUp-button">
                <Button
                  radius="xl"
                  size="md"
                  sx={themeProvider}
                  onClick={closeModal}
                  style={{
                    width: "100%",
                    backgroundColor: "#1c7ea0",
                    fontSize: "11px",
                  }}
                >
                  {" "}
                  {translate(TranslationEnum.common_portal,"CONTINUE")}
                </Button>
              </Box>
            </Box>
          </Box>
        </div>
      </Modal>
    </div>
  );
}
